// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__2549w","hint":"styles_hint__iPBZ6"};